module.exports = __webpack_public_path__ + "static/media/DailyBonus_Prizes_BottomBar@3x.59206f52.png";